import React, { useEffect, useRef, useState } from "react";
import { get } from "lodash";
import { Field } from "redux-form";

import { clearSearch } from "./Helper";
import { useSelector } from "react-redux";
import { getIcon } from "../../../helpers/icons";
import { DropdownAsync } from "../../../components/Field";
import SearchEmpty from "./SearchEmpty";
import Link from "../../../components/Link";
import List from "../../../components/List";
import Title from "../../../components/Title";
import Spinner from "../../../components/Spinner";
import Section from "../../../components/Section";
import Card from "../../Widgets/ArticleCarousel/Card";
import Input from "../../../components/Field/Input/Input";

import style from "./style.module.css";

export default function FilterHeader({ status, setFilter, winHeight }) {
    const seriesRef = useRef(null);
    const categoryRef = useRef(null);
    const outSideClickRef = useRef(null);
    const filterHeaderRowRef = useRef(null);
    const updateTimeout = useRef(null);
    const [selectedFilters, setSelectedFilters] = useState([]);
    const [searchKeywords, setSearchKeywords] = useState({
        keyword: "",
        category: "",
        series: "",
    });
    const [searchIsActive, setSearchIsActive] = useState(false);
    const exploreRelatedList = useSelector(state => get(state.grid, "search", {}));
    useEffect(() => {
        const sectionElement = document.querySelector(`.${style.filterHeaderSection}`);
        const filterHeaderRowElement = filterHeaderRowRef.current;

        if (sectionElement && filterHeaderRowElement) {
            const calculatedHeight = winHeight - 0;
            sectionElement.style.height = `${calculatedHeight}px`;
        }
    }, [status, winHeight]);

    useEffect(() => {
        const outSideClickElement = document.querySelector(`.listLayout`);
        outSideClickRef.current = outSideClickElement;
        const handleClick = () => {
            setFilter(false);
            setSearchIsActive(false);
        };
        if (outSideClickRef.current) {
            outSideClickRef.current.addEventListener('click', handleClick);
        }
        return () => {
            if (outSideClickRef.current) {
                outSideClickRef.current.removeEventListener('click', handleClick);
            }
        };
        // eslint-disable-next-line
    }, [status]);

    useEffect(() => {
        if (searchKeywords.keyword === "" && searchKeywords.category === "" && searchKeywords.series === "") {
            setSearchIsActive(false)
        }
    }, [searchKeywords.keyword, searchKeywords.category, searchKeywords.series]);

    useEffect(() => {
        const htmlElement = document.documentElement;
        if(searchIsActive === true) {
            htmlElement.classList.add("seachHeaderActive");
        }
        else {
            htmlElement.classList.remove("seachHeaderActive");
        }
    }, [searchIsActive])

    const handleSelectChange = (type, value, formValues) => {
        setSearchIsActive(true);
        if (value === "") {
            const checkboxes = document.querySelectorAll(`input[data-type="${type}"]`);
            checkboxes.forEach(checkbox => {
                checkbox.checked = false;
            });
            const filteredFilters = selectedFilters.filter(filter => filter !== (type === "category" ? categoryRef.current.value : seriesRef.current.value));
            setSelectedFilters(filteredFilters);
        }
    };

    const handleCheckboxChange = (event, item, change) => {
        const { checked, value } = event.target;
        const { type } = event.target.dataset;
        let newSelectedFilters = [...selectedFilters];
        if (checked) {
            newSelectedFilters.push(value);
        } else {
            newSelectedFilters = newSelectedFilters.filter(filter => filter !== value);
        }
        if (checked) {
            newSelectedFilters = newSelectedFilters.filter(filter => {
                const filterElement = document.querySelector(`input[data-type="${type}"][value="${filter}"]`);
                if (filterElement && filterElement !== event.target) {
                    filterElement.checked = false;
                    return false;
                }
                return true;
            });
        }
        setSelectedFilters(newSelectedFilters);
        if (item.type === "category") {
            change("category", checked ? value : "");
        } else if (item.type === "series") {
            change("series", checked ? value : "");
        }
    };

    return (
        status ? (
            <div className={`${style.filterHeader} ${searchIsActive === true ? style.active : ""}`}>
                <Section center={false} id="filterHeaderSection" className={`filterHeaderSection ${style.filterHeaderSection}`}>
                    <>
                        <List
                            url="/search"
                            emptyText="No search result"
                            attribute="search"
                            className={style.searchListLayout}
                            infiniteScrollElement={`.listLayout`}
                            listClassName={style.searchList}
                            sort={false}
                            limit={20}
                            countQuery={1}
                            loadOnValidFilter={searchIsActive === true ? false : true}
                            itemTemplate={(item) => {
                                if (item.id) {
                                    return (
                                        <Card
                                            item={item}
                                            onClick={() => {
                                                setFilter(false);
                                            }}
                                            onHover={() => { }}
                                        />
                                    )
                                }
                            }}
                            searchForm={(props) => {
                                const { fetching, formValues, change } = props;
                                const newProps = { ...props };
                                return (
                                    <>
                                        <div className={`${style.filterHeaderRow} ${style.customSection}`} ref={filterHeaderRowRef}>
                                            <div className={style.col1}>
                                                <div className={style.seachBoxWrap}>
                                                    <Link onClick={() => { setFilter(false) }} className={style.filterHeaderClose}>
                                                        <i className={getIcon("Close")}></i>
                                                    </Link>
                                                    <div className={style.inputRow}>
                                                        <i className={getIcon("search")}></i>
                                                        <Field
                                                            name="keyword"
                                                            component={Input}
                                                            search={true}
                                                            onKeyDown={(event) => {
                                                                const { value } = event.target;
                                                                if (value.length === 1 && event.key === "Backspace") {
                                                                    clearSearch(newProps);
                                                                    setSearchIsActive(false);
                                                                    setSearchKeywords(prevState => ({
                                                                        ...prevState,
                                                                        keyword: ""
                                                                    }));
                                                                }
                                                                else if (value.length > 0) {
                                                                    setSearchIsActive(true);
                                                                }
                                                            }}
                                                            onChange={(event) => {
                                                                const { value } = event.target;
                                                                if (value.length > 0) {
                                                                    setSearchIsActive(true);
                                                                    setSearchKeywords(prevState => ({
                                                                        ...prevState,
                                                                        keyword: value
                                                                    }));
                                                                } else {
                                                                    setSearchKeywords(prevState => ({
                                                                        ...prevState,
                                                                        keyword: ""
                                                                    }));
                                                                }
                                                            }}
                                                            placeholder="Search by: Keyword, Episode name, Episode number, Date, Series"
                                                        />
                                                        {
                                                            get(formValues, "keyword", "") !== "" && fetching === false && (
                                                                <Link
                                                                    onClick={() => {
                                                                        clearSearch(newProps)
                                                                        setSearchKeywords(prevState => ({
                                                                            ...prevState,
                                                                            keyword: ""
                                                                        }));
                                                                    }}
                                                                >
                                                                    <i className={getIcon("Close")}></i>
                                                                </Link>
                                                            )
                                                        }
                                                        {
                                                            fetching === true && (
                                                                <div className={style.inputLoading}>
                                                                    <i class="fas fa-spinner fa-spin"></i>
                                                                </div>
                                                            )
                                                        }
                                                    </div>
                                                </div>
                                                <div className={style.dropdownWrap}>
                                                    <div className={style.rightFilterList}>
                                                        <Title tag="p">Filters</Title>
                                                        <div className={style.filterList}>
                                                            <div className={`${style.filterListItem} ${style.filterListItem1}`}>
                                                                <Field
                                                                    name="category"
                                                                    component={DropdownAsync}
                                                                    params={{ url: "category" }}
                                                                    prompt="Category"
                                                                    onChange={(value) => {
                                                                        const selectElement = document.querySelector(`.${style.filterListItem1} select`);
                                                                        const selectedOption = selectElement.options[selectElement.selectedIndex];
                                                                        const label = selectedOption.text;
                                                                        if (updateTimeout.current) {
                                                                            clearTimeout(updateTimeout.current);
                                                                        }
                                                                        updateTimeout.current = setTimeout(() => {
                                                                            setSearchKeywords(prevState => ({
                                                                                ...prevState,
                                                                                category: label !== "Category" ? label : ""
                                                                            }));
                                                                        }, 1500);
                                                                        handleSelectChange("category", value, formValues);
                                                                    }}
                                                                    ref={categoryRef}
                                                                />
                                                            </div>
                                                            <div className={`${style.filterListItem} ${style.filterListItem2}`}>
                                                                <Field
                                                                    name="series"
                                                                    component={DropdownAsync}
                                                                    params={{ url: "series" }}
                                                                    prompt="Series"
                                                                    onChange={(value) => {
                                                                        const selectElement = document.querySelector(`.${style.filterListItem2} select`);
                                                                        const selectedOption = selectElement.options[selectElement.selectedIndex];
                                                                        const label = selectedOption.text;
                                                                        if (updateTimeout.current) {
                                                                            clearTimeout(updateTimeout.current);
                                                                        }
                                                                        updateTimeout.current = setTimeout(() => {
                                                                            setSearchKeywords(prevState => ({
                                                                                ...prevState,
                                                                                series: label !== "Series" ? label : ""
                                                                            }));
                                                                        }, 1500);
                                                                        handleSelectChange("series", value, formValues);
                                                                    }}
                                                                    ref={seriesRef}
                                                                />
                                                            </div>
                                                            <div className={style.filterListItem}>
                                                                <Field
                                                                    name="media_type"
                                                                    component={DropdownAsync}
                                                                    params={{ url: "media-type" }}
                                                                    prompt="Media Type"
                                                                    onChange={(value) => handleSelectChange("media_type", value, "", formValues)}
                                                                />
                                                            </div>
                                                        </div>
                                                        <Link
                                                            onClick={() => {
                                                                setFilter(false)
                                                                clearSearch(newProps)
                                                                setSearchIsActive(false)
                                                                setSearchKeywords(({
                                                                    keyword: "",
                                                                    category: "",
                                                                    series: ""
                                                                }));
                                                            }}
                                                            className={style.filterHeaderClose}
                                                        >
                                                            <i className={getIcon("Close")}></i>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                            {
                                                exploreRelatedList.data.explore_related_content !== undefined &&
                                                exploreRelatedList.data.explore_related_content.length > 0 &&
                                                (
                                                    <div className={`${style.col1} ${style.relatedCategoryHeader}`}>
                                                        <div className={style.relatedCategoryRow}>
                                                            <Title tag="p">Explore content related to: </Title>
                                                            <div className={style.exploreRelatedList}>
                                                                {
                                                                    exploreRelatedList.data.explore_related_content.map((item, index) => {
                                                                        return (
                                                                            <label key={`filterCheckBoxLabel_${index}`} className={style.filterCheckBoxLabel}>
                                                                                <input
                                                                                    type="checkbox"
                                                                                    className={style.filterCheckBox}
                                                                                    name="filterCheckBox"
                                                                                    value={item.id}
                                                                                    data-type={item.type}
                                                                                    checked={selectedFilters.includes(item.id)}
                                                                                    onChange={(event) => handleCheckboxChange(event, item, change)}
                                                                                />
                                                                                <span>{item.name}</span>
                                                                            </label>
                                                                        )
                                                                    })
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        </div>
                                        {
                                            fetching === true && (
                                                <div className={style.spinner}>
                                                    <Spinner />
                                                </div>
                                            )
                                        }
                                    </>
                                )
                            }}
                        />
                        {
                            exploreRelatedList.data.related_content !== undefined &&
                            exploreRelatedList.data.total === 0 &&
                            (searchKeywords.keyword !== "" || searchKeywords.category !== "" || searchKeywords.series !== "") && (
                                <SearchEmpty
                                    keyword={searchKeywords.keyword}
                                    category={searchKeywords.category}
                                    series={searchKeywords.series}
                                    related_content={exploreRelatedList.data.related_content}
                                />
                            )
                        }
                    </>
                </Section>
            </div>
        ) : null
    )
}